<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__accent">
      {{ 'SHARED.TOOLBAR_STORES_LABEL' | translate }}
    </h3>

    <div
      *ngIf="!is_membership_list_running && store_memberships?.length"
      class="sp-margin__top-x2">
      <div
        class="sp-width__full sp-row__align sp-wrap sp-margin__bottom-x2"
        *ngFor="let store_membership of store_memberships">
        <div class="sp-row__space sp-width__full">
          <div class="sp-row__align">
            <app-shared-store-logo
              matPrefix
              size="s"
              [current_store_logo]="store_membership?.store_logo_icon"></app-shared-store-logo>
            <p class="sp-margin__left sp-margin__right-x2 sp-color__primary">
              {{ store_membership?.store_name }}
            </p>
          </div>

          <div
            class="sp-padding__horiz sp-border-radius sp-width__fit-content"
            [ngClass]="
              store_membership.role == 'owner'
                ? 'sp-background__accent sp-color__accent-contrast'
                : 'sp-background__primary-light sp-color__primary'
            ">
            <span class="sp-text__ellipsized">
              {{ store_membership.seller_role }}
            </span>
          </div>
        </div>
        <hr class="sp-width__full sp-stroke sp-stroke__dashed-dark sp-margin__top" />
      </div>
    </div>

    <div
      *ngIf="!is_membership_list_running && !store_memberships?.length"
      class="sp-margin__top-x2">
      <hr class="sp-width__full sp-stroke sp-stroke__dashed-dark sp-margin__bottom" />
      <p class="sp-color__primary sp-text__center">
        {{ 'STORES.EMPTY_LABEL' | translate }}
      </p>
      <hr class="sp-width__full sp-stroke sp-stroke__dashed-dark sp-margin__top sp-margin__bottom-x2" />
    </div>

    <div
      *ngIf="is_membership_list_running"
      class="sp-margin__top-x2"
      style="height: 100px">
      <app-loading [card_radius]="'sp-border-radius__xs'"></app-loading>
    </div>
  </div>
</div>
